import { debounce } from 'lodash-es';
import { useEffect, useRef, useState } from 'react';

export const useMatchMedia = () => {
  const [isMobile, setIsMobile] = useState(false);

  const checkIfMobileViewSize = () => {
    const nowIsMobile =
      window.matchMedia('(max-width: 560px)').matches ||
      /iPhone|iPod|Android|BlackBerry|Windows Phone/i.test(window.navigator.userAgent);

    setIsMobile(nowIsMobile);
  };

  const debounced = useRef(debounce(checkIfMobileViewSize, 100));

  useEffect(() => {
    const debouncedCur = debounced.current;

    if (!window) {
      return;
    }

    checkIfMobileViewSize();
    window.addEventListener('resize', debouncedCur);

    return () => window.removeEventListener('resize', debouncedCur);
  }, []);

  return isMobile;
};
